import React from "react";
import styled from "styled-components/macro";
import { Layout as AntdLayout } from "antd";
import { withRouter } from "react-router-dom";

import TopBar from "./TopBar";

const Container = styled(AntdLayout)`
  min-height: 100vh;
  flex: 1 !important;

  @media print {
    display: block;
  }
`;

const Layout = ({ children }) => {
  return (
    <Container>
      <TopBar />
      {children}
    </Container>
  );
};

const enhancer = withRouter; // https://github.com/ReactTraining/react-router/issues/4671

export default enhancer(Layout);
